import React, { useRef } from "react"
import useDynamicScriptEmbed from "hooks/useDynamicScriptEmbed"

import { Content, Wrapper, Youtube } from "./styles"

const Embed = ({ element }) => {
  const { priority, source, embedCode, link } = element

  const contentRef = useRef(null);
  useDynamicScriptEmbed(contentRef, embedCode);

  return (
    <Wrapper priority={priority}>
      {source === "YouTube" && link ? (
        <Youtube>
          <iframe
            type="text/html"
            title="Watch the article YouTube video"
            src={link.replace("watch?v=", "embed/")}
            width="100%"
            height="auto"
            allowFullScreen
            frameBorder="0"
          />
        </Youtube>
      ) : (
        <Content ref={contentRef} />
      )}
    </Wrapper>
  )
}

export default Embed
